import React from 'react';
// styles
const styles = require('./contact-us.scss');

interface IProps {
  userBookingRef: string;
  userEmail: string;
  language: string;
  multiLang: any;
  CSlink: string;
}

interface IState {
  userBookingRef: string;
  userEmail: string;
  isLoading: boolean;
}
class ContactUsComponent extends React.Component<IProps, IState> {

  private intervalTimer = null;

  constructor(props: any) {
    super(props);
    this.state = {
      userBookingRef: props.userBookingRef,
      userEmail: props.userEmail,
      isLoading: false
    }
  }

  handleChatClick() {
    this.setState({ isLoading: true });

    if (typeof (window as any).zE === 'undefined') {
      const scriptElem = document.createElement('script');
      scriptElem.innerHTML = `window.zEmbed||function(e,t){var n,o,d,i,s,a=[],r=document.createElement("iframe");window.zEmbed=function(){a.push(arguments)},window.zE=window.zE||window.zEmbed,r.src="javascript:false",r.title="",r.role="presentation",(r.frameElement||r).style.cssText="display: none",d=document.getElementsByTagName("script"),d=d[d.length-1],d.parentNode.insertBefore(r,d),i=r.contentWindow,s=i.document;try{o=s}catch(e){n=document.domain,r.src='javascript:var d=document.open();d.domain="'+n+'";void(0);',o=s}o.open()._l=function(){var o=this.createElement("script");n&&(this.domain=n),o.id="js-iframe-async",o.src=e,this.t=+new Date,this.zendeskHost=t,this.zEQueue=a,this.body.appendChild(o)},o.write('<body onload="document._l();">'),o.close()}("https://assets.zendesk.com/embeddable_framework/main.js","portr.zendesk.com");`;
      document.body.appendChild(scriptElem);

      if (this.intervalTimer) { clearInterval(this.intervalTimer); }

      this.intervalTimer = setInterval(() => {
        if (typeof (window as any).zE !== 'undefined') {
          clearInterval(this.intervalTimer);
          this.openChat();
          this.setState({ isLoading: false });
        }
      }, 1000);

    } else {
      this.openChat();
      this.setState({ isLoading: false });
    }

  }

  openChat() {
    (window as any).zE(function (this) {
      (window as any).zE.activate({ hideOnClose: true });
      (window as any).zE.identify({ name: 'Booking Ref: ' + this.state.userBookingRef, email: this.state.userEmail });
    }.bind(this));
  }

  public render() {
    const { language, multiLang } = this.props;

    return (
      <div className={styles.row}>
        <a className={styles.btnAccent} target='_blank' href={this.props.CSlink}>{multiLang[`contactUs${language}`]}</a>
        {/* <button className={styles.btnPrimary} onClick={e => this.handleChatClick()}>
          {this.state.isLoading
            ? <div className={styles.loader}></div>
            : multiLang[`chatWithUsButton${language}`]
          }
        </button> */}
      </div>
    );
  }

}

export default ContactUsComponent;



// WEBPACK FOOTER //
// ./src/components/contact-us/contact-us.component.tsx